import React from 'react';
import { Box } from '@mui/material';
import { BRAND_COLORS, FONTS } from '../types/index.ts';

export interface StatusItem {
  k: string;
  v: string;
}

interface StatusRailProps {
  items: StatusItem[];
  trailing?: string; // right-aligned (e.g. date)
  onDark?: boolean; // when placed directly on the dark console header
}

// The always-on mono readout strip beneath the console header — the "this is an
// instrument, not an admin panel" tell. Keys in slate, values in ink, cyan dot
// separators (graphic only).
const StatusRail: React.FC<StatusRailProps> = ({ items, trailing, onDark = false }) => {
  const keyColor = onDark ? 'rgba(255,255,255,0.55)' : BRAND_COLORS.slateText;
  const valColor = onDark ? '#fff' : BRAND_COLORS.ink;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 2, sm: 3.25 },
        flexWrap: 'wrap',
        px: { xs: 2, sm: 3 },
        py: 0.9,
        backgroundColor: onDark ? 'rgba(255,255,255,0.06)' : 'rgba(255,255,255,0.55)',
        borderBottom: `1px solid ${onDark ? 'rgba(255,255,255,0.12)' : 'rgba(23,34,46,0.14)'}`,
        fontFamily: FONTS.mono,
        fontFeatureSettings: '"tnum" 1',
        fontSize: 12,
        lineHeight: 1.2,
      }}
    >
      {items.map((it) => (
        <Box component="span" key={it.k} sx={{ whiteSpace: 'nowrap' }}>
          <Box component="span" sx={{ color: keyColor }}>
            {it.k}
          </Box>{' '}
          <Box component="span" sx={{ color: BRAND_COLORS.cyan }}>
            ·
          </Box>{' '}
          <Box component="span" sx={{ color: valColor, fontWeight: 600 }}>
            {it.v}
          </Box>
        </Box>
      ))}
      {trailing && (
        <Box component="span" sx={{ ml: 'auto', color: keyColor, whiteSpace: 'nowrap' }}>
          {trailing}
        </Box>
      )}
    </Box>
  );
};

export default StatusRail;
